export default __webpack_public_path__ + "static/media/mike.d34d0690.jpg";